import { httpRequest } from "@services/http";

export interface ContractBalance {
  contract_id: number;
  balance: number;
}

export class CommandGetBalance {
  async run(contractId: number): Promise<ContractBalance> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/balance/`;
    const response = await httpRequest<any>(url, { method: "GET" });
    return { contract_id: response.contract_id, balance: Number(response.balance ?? 0) };
  }
}
